import { render } from "./FontStyleSettings.vue?vue&type=template&id=684755f0"
import script from "./FontStyleSettings.vue?vue&type=script&lang=js"
export * from "./FontStyleSettings.vue?vue&type=script&lang=js"

import "./FontStyleSettings.vue?vue&type=style&index=0&id=684755f0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__